import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import Products from "@/pages/Products";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Customers from "@/pages/Customers";
import AddressForm from "@/pages/AddressForm";
import Catalogs from "@/pages/Catalogs";
import CatalogView from "@/pages/CatalogView";
import DeliveryEstimate from "@/pages/DeliveryEstimate";
import Settings from "@/pages/Settings";
import SalesReport from "@/pages/SalesReport";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />
            <Route path="/address/:token" element={<AddressForm />} />
            <Route path="/catalog/:token" element={<CatalogView />} />

            {/* Protected admin */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="pos" element={<POS />} />
              <Route path="products" element={<Products />} />
              <Route path="orders" element={<Orders />} />
              <Route path="orders/:id" element={<OrderDetail />} />
              <Route path="catalogs" element={<Catalogs />} />
              <Route path="customers" element={<Customers />} />
              <Route path="delivery-estimate" element={<DeliveryEstimate />} />
              <Route path="reports" element={<SalesReport />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
